<div class="aelogin">
    <header id="header">
        <img alt="Angkor image" class="content-image">
    </header>
    <div class="container">
        <div class="cover">
            <div class="divider-side">
                <svg class="divider" xmlns="http://www.w3.org/2000/svg" width="210.872" height="1080.062" viewBox="0 0 210.872 1080.062">
					<path class="shadow" id="Exclusion_1" data-name="Exclusion 1" d="M72.415,1080.062H0V.062H72.381C72.165.455,67,9.833,60.331,25.518c-3.789,8.914-7.347,18.17-10.573,27.51-4.007,11.6-7.519,23.385-10.437,35.023-7.385,29.45-11.1,58.274-11.053,85.671.063,34.122,6.006,66.146,17.663,95.183a264.3,264.3,0,0,0,10.8,30.042c4.042,9.545,8.8,19.581,14.535,30.68,10.679,20.654,22.822,41.263,35.679,63.082l0,.006C123.735,421.2,141.09,450.651,155,480.368a377.2,377.2,0,0,1,17.91,44.89c2.468,7.7,4.559,15.32,6.217,22.661a220.087,220.087,0,0,1,3.931,22.787,121.008,121.008,0,0,1,.5,20.823,184.116,184.116,0,0,1-2.834,22.715c-2.734,14.831-7.261,31.251-13.84,50.2-5.5,15.843-12.6,33.848-21.694,55.043-8.141,18.969-17.168,38.849-25.9,58.074-25.7,56.6-52.269,115.119-64.95,167.956a285.452,285.452,0,0,0-6.688,38.47c-.613,6.273-.94,12.41-.971,18.239a158.962,158.962,0,0,0,.84,17.462,130.246,130.246,0,0,0,2.822,16.6,111.566,111.566,0,0,0,4.974,15.653,100.494,100.494,0,0,0,17.09,28.122ZM210.872.062H72.381L72.415,0H210.872V.061h0Z" transform="translate(210.872 1080.062) rotate(180)" fill="#fff"/>
				</svg>
            </div>

            <!-- <img class="mask" src="/assets/img/Path 24@1X.png"> -->
            <div class="description">
                <article>
                    <header>
                        <h2 class="sf set-max-width set-margin-left">{{ 'LOGIN.TITLE' | translate }}</h2>
                    </header>
                    <p class="set-font-size set-max-width set-font-size">{{ 'LOGIN.DESC' | translate }}</p>
                </article>
            </div>
            <footer class="store">
                <span class="vailable">{{'LABEL.AVAILABLE' | translate}}</span>
                <div class="app-available">
                    <img class="link-store playstore" alt="playstore" (click)="_googlePlay()" src="/assets/img/google-play.png">
                    <img class="link-store appstore" alt="appstore" (click)="_appStore()" src="/assets/img/app-store.png">
                </div>
            </footer>
        </div>
        <div class="form between">
            <div class="main flex-col cm">
                <router-outlet></router-outlet>
                <div class="app-available">
                    <img class="link-store playstore" alt="playstore" (click)="_googlePlay()" src="/assets/img/google-play.png">
                    <img class="link-store appstore" alt="appstore" (click)="_appStore()" src="/assets/img/app-store.png">
                </div>
            </div>
            <footer>
                <nav>
                    <ul class="navigate flex-row">
                        <li class="simple-padding"><button (click)="onOpenManual()" mat-button class="text-light">{{'LABEL.MANUAL' | translate}}</button></li>
                        <li class="simple-padding"><button (click)="getContactUrl()" mat-button class="text-light">{{'LABEL.CONTACT_US' | translate}}</button></li>
                        <li class="simple-padding"><button (click)="openPrivacyDialog()" mat-button class="text-light">{{'LABEL.PRIVACY' | translate}}</button></li>
                        <!-- <li class="simple-padding"><a class="text-light" href="#">{{'LABEL.TERMS' | translate}}</a></li> -->
                        <!-- <li class="simple-padding"><a class="text-light" href="#">{{'LABEL.TERMS' | translate}}</a></li> -->
                        <li>
                            <button mat-button [matMenuTriggerFor]="lang">
								<img src="../../../../assets/img/{{currentLang}}.svg" width="50" height="20" alt="">
								<span>{{ 'LANG.' + currentLang | translate }}</span>
							</button>
                            <mat-menu #lang class="set-font-size">
                                <menu class="menu-lang" mat-menu-item *ngFor="let lang of languages" (click)="changeLang(lang)">
                                    <img src="../../../../assets/img/{{lang.code}}.svg" width="50" height="20" alt="">
                                    <span>{{ 'LANG.' + lang.code | translate }}</span>
                                </menu>
                            </mat-menu>
                            <!-- <p class="lang-default">
								<img src="../../../../assets/img/{{currentLang}}.svg" width="50" height="20" alt="">
								<span>{{ 'LANG.' + currentLang | translate }}</span>
							</p> -->
                        </li>
                    </ul>
                </nav>
            </footer>
        </div>
    </div>
</div>

<ng-template #manualDialog>
    <mat-dialog-content class="manual-container">
        <img class="manual-image" src="/assets/img/Online-Ticket-Manual.jpg">
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button class="mat-custom-btn" (click)="onDownloadManual()" mat-flat-button color="primary">{{ 'LABEL.DOWNLOAD' | translate }}</button>
        <button class="mat-custom-btn" mat-flat-button mat-dialog-close color="accent">{{ 'LABEL.CLOSE' | translate }}</button>
        <!-- <button mat-button class="text-light">Close</button> -->
    </mat-dialog-actions>
</ng-template>
